module.exports = __webpack_public_path__ + "static/screenshot1-3f532a7b4d315d8d4d64b195e7e50ca6.png";